import {mapActions, mapGetters} from 'vuex'
import { LinkList, ReformatNumber, ReformatDate, RoleListInt,ApprovalStageBoq, ApprovalStageBoqObj, ModuleActionList ,ReformatFileName } from '@/helpers/utilities.js' 
import {UploadFileToFolder} from '@/helpers/msalHelpers.js'
import StepItem2 from '@/components/layout/StepItem2.vue'
import Select2 from '@/components/layout/Select2.vue'
import Modal from '@/components/layout/Modal.vue'
import Loader from '@/components/layout/Loader.vue'
import ModalNewLineItem from '@/components/boq/ModalNewLineItem.vue'
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import {GetQuotationOne, SearchUserFromProjectDirectory, UpdateQuotation,
    SearchBoqNoQuotations,AddBoQtoQuotation, ForApprovalQuotation, PublishQuotation, CreateBoq, ValidateQuotationBeforeApproval, GetBoQsQuotationSummaries} from '@/actions/boqActions.js'
import {SearchProjectProcessApproval,GetProcessItemQuotation, GetTokenSharepointFromAuth, GetProjectSharepointFolders, GetSystemSettings} from '@/actions/projectActions.js'
import {GetUserSignature} from '@/actions/userActions.js'
import RichTextEditor from '@/components/layout/RichTextEditor.vue'
import BoqProcessWorkFlow  from '@/components/projectInformation/BoqProcessWorkFlow.vue'
import DatePicker from '@/components/layout/DatePicker.vue'
import BoqQuotationBoqSummary from '@/components/boq/BoqQuotationBoqSummary.vue'
import BoqQuotationHeaderReadOnly from '@/components/boq/BoqQuotationHeaderReadOnly.vue'
import FigureCurrencyNote from '@/components/layout/FigureCurrencyNote.vue'
import QuotationFeedback from '@/components/boq/QuotationFeedback.vue'
import 'dotenv/config'
export default {
    name : 'ConsolidatedList',
    components : {
        StepItem2, BreadcrumbsProject,RichTextEditor, Select2,
         Modal, Loader,ModalNewLineItem,BoqProcessWorkFlow, DatePicker,
         BoqQuotationBoqSummary, BoqQuotationHeaderReadOnly,
         FigureCurrencyNote, QuotationFeedback
    },
    mounted : async function(){
        const self = this
        const quotationId = self.$route.params.id

        this.sharepointToken = await GetTokenSharepointFromAuth() 

        let getQuotation = await GetQuotationOne(quotationId)
        if(getQuotation=='401'){
            return self.$router.push('/unauthorized')
        }
        const jsonQuotation = self.ReformatJson(getQuotation)
        self.quotationData = JSON.parse(JSON.stringify(jsonQuotation))
        self.quotationDataIntial = JSON.parse(JSON.stringify(jsonQuotation))

        self.ChangeActiveLink(LinkList.QUOTATIONS)
        await self.GetProjectInfo(getQuotation.projectId._id).catch()
        // self.summaryList = await GetQuotationSummary(quotationId)
        self.summaryByBoqList = await GetBoQsQuotationSummaries(quotationId)
        self.isSummaryLoading = false
        self.isLoading = false
        self.approvalProcessList = await SearchProjectProcessApproval(getQuotation.projectId._id,'')
        self.boqList = await SearchBoqNoQuotations({id : this.projectInfo._id,search : ''})
        self.sharepointFolders = await GetProjectSharepointFolders(this.projectInfo._id)
        self.systemSettings = await GetSystemSettings()

        if(getQuotation.approvalStage==ApprovalStageBoq.FOR_APPROVAL){
            const processData = await GetProcessItemQuotation(getQuotation._id).catch()
            self.processItemData = processData
        }

        self.isEditMode = this.$route.query.isEdit || false

        
        for(let x= 0; x< self.quotationData.submittedTo.length; x++){
            const getSubmitter = self.quotationData.submittedTo[x]
            const getSignature = await GetUserSignature({projectId : getQuotation.projectId._id, userId : getSubmitter.userId._id})
            if(getSignature && getSignature.message == "OK"){
                self.quotationData.submittedTo[x].signature = getSignature.result
                // Convert the decoded string to a Uint8Array
                let decodedBlobData = Buffer.from(getSignature.result.signature,'base64').toString('binary')
                let byteNumbers  = new Array(decodedBlobData.length)
                for (let i = 0; i < decodedBlobData.length; i++) {
                    byteNumbers[i] = decodedBlobData.charCodeAt(i)
                }
                const byteArray = new Uint8Array(byteNumbers);
                self.quotationData.submittedTo[x].signatureBlob = URL.createObjectURL(new Blob([byteArray] , { type: getSignature.result.mimeType }))
            }
        }
        await self.$nextTick()
        self.SetQuotationBaseline()
        self.suspendChangeTracking = false
    },
    methods : {
        ...mapActions(['ChangeActiveLink', 'GetProjectInfo']),
        ReformatNumber  :ReformatNumber,
        ReformatDate : ReformatDate,
        SearchUserFromProjectDirectory (value){
            return SearchUserFromProjectDirectory(value,0,this.projectInfo._id)
        },
        SearchClientFromProjectDirectory (value){
            return SearchUserFromProjectDirectory(value,RoleListInt.CLIENT,this.projectInfo._id)
        },
        ShowQuotationFeedbackModal(type, title, message, options = {}){
            this.quotationFeedbackModal = {
                visible : true,
                type,
                title,
                message,
                confirmText : options.confirmText || ''
            }
        },
        CloseQuotationFeedbackModal(){
            this.quotationFeedbackModal = {
                ...this.quotationFeedbackModal,
                visible : false
            }
        },
        ShowQuotationFeedbackToast(type, title, message){
            this.quotationFeedbackToast = {
                visible : true,
                type,
                title,
                message
            }
        },
        CloseQuotationFeedbackToast(){
            this.quotationFeedbackToast = {
                ...this.quotationFeedbackToast,
                visible : false
            }
        },
        GetApprovalStageName(stage){
            return ApprovalStageBoqObj[stage -1]?.name || ''
        },
        GetStatusClass(stage){
            if(!this.isDeluxeLayout){
                return 'badge ' + ApprovalStageBoqObj[stage -1].color
            }

            if([5,8].indexOf(stage)>-1){
                return 'pill-completed'
            }

            if([2,3,4].indexOf(stage)>-1){
                return 'pill-in-progress'
            }

            if(stage==6){
                return 'pill-warning'
            }

            return 'pill-state'
        },
        SearchBoqNoQuotations(value){
            return SearchBoqNoQuotations({id : this.projectInfo._id,search : value})
        },
        AddNewSubmittedLine(){
            const getLastItem = this.submittedTo[this.submittedTo.length -1]
            if(getLastItem){
                if(!getLastItem.directoryId){
                    return
                }
            }

            this.submittedTo.push({
                directoryId : '',
                name : ''
            })
        },
        AddNewAttentionClient(){
            const getLastItem = this.additionalAttention[this.additionalAttention.length -1]
            if(getLastItem){
                if(!getLastItem.directoryId){
                    return
                }
            }

            this.additionalAttention.push({
                directoryId : '',
                name : ''
            })
        },
        RemoveSubmittedLine(id){
            if(this.submittedTo.length==1){
                return 
            }
            const getIndex =  this.submittedTo.findIndex(u=>u.directoryId==id)
            if(getIndex>-1){
                this.submittedTo.splice(getIndex,1)
            }
        },
        RemoveAdditionalClientLine(id){
            if(this.additionalAttention.length==1){
                return 
            }
            const getIndex =  this.additionalAttention.findIndex(u=>u.directoryId==id)
            if(getIndex>-1){
                this.additionalAttention.splice(getIndex,1)
            }
        },
        NormalizeRichTextSpaces(value){
            if(typeof value !== 'string'){
                return value || ''
            }

            return value
                .replace(/&(nbsp|ensp|emsp|thinsp);/gi, ' ')
                .replace(/&#160;|&#xA0;/gi, ' ')
                .replace(/[\u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000]/g, ' ')
                .replace(/[ \t]{2,}/g, ' ')
        },
        NormalizeQuotationDateForApi(value){
            if(!value){
                return ''
            }

            const parsedDate = new Date(value)
            if(!Number.isNaN(parsedDate.getTime())){
                return ReformatDate(parsedDate, 'YYYY-MM-DD')
            }

            return ReformatDate(value, 'YYYY-MM-DD')
        },
        EscapeHtml(value){
            return String(value || '').replace(/[&<>"']/g, (char) => ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            }[char]))
        },
        IsChineseLocale(){
            const activeLocale = this.$i18n?.locale?.value || this.$i18n?.locale
            const storedLocale = typeof window !== 'undefined' ? window.localStorage.getItem('z_locale') : ''
            const locale = String(activeLocale || storedLocale || '').toLowerCase()
            return locale.indexOf('zh') === 0 || locale === 'ch'
        },
        TranslateStandardQuotationRichText(value){
            if(typeof value !== 'string' || !value){
                return value || '-'
            }

            if(!this.IsChineseLocale()){
                return value
            }

            const replacements = [
                ['All items not explicitly stated are excluded from this Quotation.', '所有未明确列出的项目均不包含在本报价中。'],
                ['Specifically excluded are:', '具体不包含以下项目：'],
                ['IT Cabling, IT Migration, IT Equipment, Inter rack cable ties &amp; Computer System', 'IT布线、IT迁移、IT设备、机柜间线缆绑扎及电脑系统'],
                ['IT Cabling, IT Migration, IT Equipment, Inter rack cable ties & Computer System', 'IT布线、IT迁移、IT设备、机柜间线缆绑扎及电脑系统'],
                ['IT Cabling, Inter-Rack Cable Ties, Rack, Equipment &amp; Computer System', 'IT布线、机柜间扎带、机柜、设备及电脑系统'],
                ['IT Cabling, Inter-Rack Cable Ties, Rack, Equipment & Computer System', 'IT布线、机柜间扎带、机柜、设备及电脑系统'],
                ['PABX and Telephone system', 'PABX 和电话系统'],
                ['PABX and Telephone System', 'PABX 和电话系统'],
                ['IT Migration', 'IT 迁移'],
                ['Security Access / CCTV System/ Intrusion Alarm System', '门禁 / 闭路电视系统 / 入侵报警系统'],
                ['Preaction Sprinkler System', '预作用喷淋系统'],
                ['Security System', '安防系统'],
                ['AV / VC System, World Clock, Room Booking System and Sound Masking', '影音 / 视频会议系统、世界时钟、会议室预订系统及声掩蔽'],
                ['AV / VC System, Room Booking System and Sound Masking', '影音 / 视频会议系统、会议室预订系统及声掩蔽'],
                ['Genset and UPS', '发电机组及 UPS'],
                ['Genset / Emergency Power Supply', '发电机组 / 应急电源'],
                ['Auxiliary Aircon except Server room', '服务器机房以外的辅助空调'],
                ['CRAC Unit / Precision Air-conditioning', 'CRAC 机组 / 精密空调'],
                ['FM200, Fire suppression system, Preaction Sprinkler system &amp; Automatic Smoke Detection System', 'FM200、灭火系统、预作用喷淋系统及自动烟雾探测系统'],
                ['FM200, Fire suppression system, Preaction Sprinkler system & Automatic Smoke Detection System', 'FM200、灭火系统、预作用喷淋系统及自动烟雾探测系统'],
                ['FM200, Fire suppression system, Preaction sprinkler system &amp; Automatic Smoke Detection System', 'FM200、灭火系统、预作用喷淋系统及自动烟雾探测系统'],
                ['FM200, Fire suppression system, Preaction sprinkler system & Automatic Smoke Detection System', 'FM200、灭火系统、预作用喷淋系统及自动烟雾探测系统'],
                ['VESDA system', 'VESDA 系统'],
                ['Environmental Monitoring System', '环境监测系统'],
                ['Exhaust and hydrogen detection system for server room', '服务器机房的排风及氢气检测系统'],
                ['LEED/ Green Mark Certification', 'LEED / 绿色建筑标志认证'],
                ['LEED / Green Mark Certification', 'LEED / 绿色建筑标志认证'],
                ['LEED / Green Mark Certifications', 'LEED / 绿色建筑标志认证'],
                ['Task Light and Photosensor', '工作灯及光电传感器'],
                ['Task Light, &amp; Lighting Scene Control System', '工作灯及灯光场景控制系统'],
                ['Task Light, & Lighting Scene Control System', '工作灯及灯光场景控制系统'],
                ['Building BMS linkage otherwise indicated', '楼宇 BMS 联动，另有说明除外'],
                ['unless otherwise indicated', '除另有说明外'],
                ['otherwise indicated', '另有说明除外'],
                ['Building Services Connection Charges Payable to Landlord', '须支付给业主的楼宇服务接驳费用'],
                ['Design Fees by Base Building Consultant', '基础建筑顾问的设计费用'],
                ['Base building consultants vetting fees', '基础建筑顾问审核费用'],
                ['Structure Engineering Fee and Load Spreader', '结构工程费用及荷载分布装置'],
                ['All Tenancy Walls, Main Entrance Door and Transfer Air Duct deemed to be by Landlord', '所有租赁隔墙、主入口门及转接风管均视为由业主提供'],
                ['All Tenancy Walls and Transfer Air Duct shall be by Landlord', '所有租赁隔墙及转接风管均由业主提供'],
                ['Office Equipment, Safes and Office Accessories ie waste bins etc', '办公设备、保险箱及办公配件，例如垃圾桶等'],
                ['Move management', '搬迁管理'],
                ['Reinstatement to existing premises', '现有场地复原工程'],
                ['Feng Shui fees and other specialist consultants fees', '风水费用及其他专业顾问费用'],
                ['Plants, Landscape works, Special Lightings / Lamps other than mentioned', '除已注明外的植物、景观工程、特殊照明/灯具'],
                ['Charges or deposits required by the Landlord/Building Management shall be borne by Client', '业主/大厦管理方要求的费用或押金由客户承担'],
                ['New or relocation of hose reel or any fire barrier', '新增或迁移消防卷盘或任何防火分隔'],
                ['All Goods and Services Tax', '所有商品及服务税'],
                ['World Clock, Name Plates and Mover Cost', '世界时钟、铭牌及搬迁费用'],
                ['White goods', '白色家电'],
                ['Fit out Work is strictly confined to tenanted space and excludes all existing building toilets, staircase areas and common corridor areas', '装修工程严格限于租赁空间，不包括所有现有楼宇厕所、楼梯区域及公共走廊区域'],
                ["Co-ordination and attendance fees for all Client's Direct Vendors:", '所有客户直接供应商的协调及现场配合费用：'],
                ["Whereby M Moser help to co-ordinate Clients' Direct Vendors and help to check on any defective goods / works", '如 M Moser 协助协调客户的直接供应商并检查任何有缺陷的货物/工程'],
                ["Whereby M Moser help to finance and co-ordinate Clients' Selected Vendors AND help to check on any defective goods / works", '如 M Moser 协助垫资并协调客户选定的供应商，并检查任何有缺陷的货物/工程'],
                ['Ten (10%) percent of vendors total awarded contract sums shall be charged as M Moser’s attendance and co-ordination fee.', '将按供应商中标合同总额的百分之十 (10%) 收取作为 M Moser 的现场配合及协调费用。'],
                ["Ten (10%) percent of vendors total awarded contract sums shall be charged as M Moser's attendance and co-ordination fee.", '将按供应商中标合同总额的百分之十 (10%) 收取作为 M Moser 的现场配合及协调费用。'],
                ['Fifteen (15%) percent of vendors total awarded contract sums shall be charged as M Moser’s attendance and co-ordination fee.', '将按供应商中标合同总额的百分之十五 (15%) 收取作为 M Moser 的现场配合及协调费用。'],
                ["Fifteen (15%) percent of vendors total awarded contract sums shall be charged as M Moser's attendance and co-ordination fee.", '将按供应商中标合同总额的百分之十五 (15%) 收取作为 M Moser 的现场配合及协调费用。'],
                ['This attendance fee includes co-ordination with these vendors, provision of cleaning, protection on site and other preliminary works.', '该现场配合费用包括与这些供应商协调、提供清洁、现场保护及其他前期工程。'],
                ['Payment Terms', '付款条款'],
                ['Deposit Payment', '定金付款'],
                ['1st Progressive Payment', '第一期进度付款'],
                ['2nd Progressive Payment', '第二期进度付款'],
                ['3rd Progressive Payment', '第三期进度付款'],
                ['4th Progressive Payment', '第四期进度付款'],
                ['Progressive Payment', '进度付款'],
                ['Final Payment', '尾款'],
                ['Any variation orders, if any, shall be paid:', '如有任何变更单，应按以下方式付款：'],
                ['Any variation orders, if any, shall be paid progressively', '如有任何变更单，应按进度付款'],
                ['Any variation orders, if any, shall be paid', '如有任何变更单，应按以下方式付款'],
                ['upon signing of this Quotation or Letter of Appointment or the Memorandum of Agreement, whichever is earlier.', '在签署本报价单、委任书或协议备忘录时支付，以较早者为准。'],
                ['Payment shall be within seven (7) days.', '付款须在七 (7) 天内完成。'],
                ['Payment shall be within seven (7) days', '付款须在七 (7) 天内完成'],
                ['Payment shall be within fourteen (14) days.', '付款须在十四 (14) 天内完成。'],
                ['Payment shall be within fourteen (14) days', '付款须在十四 (14) 天内完成'],
                ['upon mid-point of construction', '在施工中期支付'],
                ['upon mid–point of construction', '在施工中期支付'],
                ['upon Handover or Practical Completion', '在移交或实际完工时支付'],
                ['upon the certified completion of all defects', '在所有缺陷经确认完成后'],
                ['upon completion of the warranty period and satisfactory rectification of defects identified at practical completion and within seven (7) days.', '在保修期结束并圆满修复实际完工时发现的缺陷后七 (7) 天内支付。'],
                ['upon completion of the warranty period and satisfactory rectification of defects identified at practical completion and within seven (7) days', '在保修期结束并圆满修复实际完工时发现的缺陷后七 (7) 天内支付'],
                ['upon completion of warranty period and satisfactory rectification of defects identified at handover and within fourteen (14) days.', '在保修期结束并圆满修复移交时发现的缺陷后十四 (14) 天内支付。'],
                ['upon completion of warranty period and satisfactory rectification of defects identified at handover and within fourteen (14) days', '在保修期结束并圆满修复移交时发现的缺陷后十四 (14) 天内支付'],
                ['upon confirmation.', '确认后支付。'],
                ['50% upon confirmation.', '50% 在确认后支付。'],
                ['50% upon confirmation', '50% 在确认后支付'],
                ['upon project completion and within seven (7) days.', '项目完成后七 (7) 天内支付。'],
                ['upon project completion and within seven (7) days', '项目完成后七 (7) 天内支付'],
                ['progressively 50% upon project completion and within fourteen (14) days.', '项目完成后十四 (14) 天内按进度支付剩余 50%。'],
                ['progressively 50% upon project completion and within fourteen (14) days', '项目完成后十四 (14) 天内按进度支付剩余 50%'],
                ['progressively 50% upon project completion', '项目完成后按进度支付剩余 50%'],
                ['Progressively 50% upon project completion and within fourteen (14) days.', '项目完成后十四 (14) 天内按进度支付剩余 50%。'],
                ['Progressively 50% upon project completion and within fourteen (14) days', '项目完成后十四 (14) 天内按进度支付剩余 50%'],
                ['and within seven (7) days.', '并须在七 (7) 天内完成。'],
                ['and within seven (7) days', '并须在七 (7) 天内完成'],
                ['and within fourteen (14) days.', '并须在十四 (14) 天内完成。'],
                ['and within fourteen (14) days', '并须在十四 (14) 天内完成'],
                ['A twelve (12) month Warranty Period will be effective from the date of Handover during which time M. Moser Associates (S) Pte Ltd will repair any defective material or workmanship without cost to the Client.', '自移交日起，十二 (12) 个月保修期生效。在此期间，M. Moser Associates (S) Pte Ltd 将免费为客户修复任何材料或工艺缺陷。'],
                ['A twelve (12) month Warranty Period will be effective from the date of Handover during which time M. Moser Associates (S) Pte Ltd will repair any defective material or workmanship without cost to the Client', '自移交日起，十二 (12) 个月保修期生效。在此期间，M. Moser Associates (S) Pte Ltd 将免费为客户修复任何材料或工艺缺陷'],
                ['A twelve (12) month 保修期 will be effective from the date of Handover during which time M. Moser Associates (S) Pte Ltd will repair any defective material or workmanship without cost to the Client.', '自移交日起，十二 (12) 个月保修期生效。在此期间，M. Moser Associates (S) Pte Ltd 将免费为客户修复任何材料或工艺缺陷。'],
                ['A twelve (12) month 保修期 will be effective from the date of Handover during which time M. Moser Associates (S) Pte Ltd will repair any defective material or workmanship without cost to the Client', '自移交日起，十二 (12) 个月保修期生效。在此期间，M. Moser Associates (S) Pte Ltd 将免费为客户修复任何材料或工艺缺陷'],
                ['Warranty Period', '保修期'],
                ['Validity of Quotation', '报价有效期'],
                ['Quotation Validity', '报价有效期'],
                ['Sixty (60) days.', '六十 (60) 天。'],
                ['Attachment', '附件']
            ]

            const translatedContent = replacements.reduce((content, [source, target]) => {
                return content.split(source).join(target)
            }, this.NormalizeRichTextSpaces(value))

            return translatedContent
                .replace(/(付款条款\s*:\s*)(\d+)\s*days/gi, '$1$2 天')
                .replace(/(报价有效期\s*:\s*)(\d+)\s*days/gi, '$1$2 天')
        },
        GetQuotationSaveErrorMessage(errorResponse){
            const fallbackMessage = this.$i18n.t('Quotation Module.Generic save error')

            if(!errorResponse){
                return fallbackMessage
            }

            if(typeof errorResponse === 'string'){
                return this.EscapeHtml(errorResponse || fallbackMessage)
            }

            const message = errorResponse.message
                || errorResponse.error
                || errorResponse.data?.message
                || errorResponse.data

            if(Array.isArray(message)){
                return message.map(this.EscapeHtml).join('<br>')
            }

            if(message && typeof message === 'object'){
                return this.EscapeHtml(JSON.stringify(message))
            }

            return this.EscapeHtml(message || fallbackMessage)
        },
        GetQuotationApprovalValidationMessage(response){
            const rawMessage = typeof response === 'string'
                ? response
                : response?.message || response?.error || response?.data?.message || response?.data || ''
            const normalizedMessage = String(rawMessage || '').toLowerCase()

            if(normalizedMessage.indexOf('bill of quantities') > -1
                || normalizedMessage.indexOf('bill of quantity') > -1
                || normalizedMessage.indexOf('boq') > -1){
                return this.FormatQuotationApprovalMissingMessage([
                    this.$i18n.t('Quotation Module.Attached Bill of Quantity')
                ])
            }

            if(normalizedMessage.indexOf('attachment') > -1){
                return this.FormatQuotationApprovalMissingMessage([
                    this.$i18n.t('Quotation Module.PDF attachment')
                ])
            }

            if(normalizedMessage.indexOf('submitted by') > -1 || normalizedMessage.indexOf('submitted to') > -1){
                return this.FormatQuotationApprovalMissingMessage([
                    this.$i18n.t('Quotation Module.Signing details')
                ])
            }

            return this.EscapeHtml(rawMessage || this.$i18n.t('Quotation Module.Please review the highlighted requirement before sending this quotation for approval'))
        },
        HasUploadedQuotationAttachments(){
            return (this.quotationData.attachments || []).some(item => item && (
                (item._id && item._id !== 0)
                || item.sharepointId
                || item.sharepointLink
            ))
        },
        HasPendingQuotationAttachments(){
            return (this.attachmentChanges || []).length > 0
                || (this.quotationData.attachments || []).some(item => item && item._id === 0 && item.attachmentName)
        },
        HasQuotationAttachments(){
            return this.HasUploadedQuotationAttachments() || this.HasPendingQuotationAttachments()
        },
        GetMissingQuotationApprovalRequirements(){
            const missing = []
            const missingQuotationDetails = !this.quotationData.contractDate
                || !String(this.quotationData.quotationNumber || '').trim()
                || !this.HasAttentionClient
                || !String(this.quotationData.quotationName || '').trim()
                || !this.quotationData.layoutDate

            this.validationErrors = {
                contractDate : !this.quotationData.contractDate,
                layoutDate : !this.quotationData.layoutDate,
                attention : !this.HasAttentionClient,
                submittedBy : !this.HasSubmittedByUser,
                submittedTo : !this.HasSubmittedToUser,
                attachedBoq : !this.HasAttachedBoq,
                // attachments : !this.HasQuotationAttachments()
            }

            if(missingQuotationDetails){
                missing.push(this.$i18n.t('Quotation Module.Quotation details'))
            }

            if(this.validationErrors.attachedBoq){
                missing.push(this.$i18n.t('Quotation Module.Attached Bill of Quantity'))
            }

            if(this.validationErrors.attachments){
                missing.push(this.$i18n.t('Quotation Module.PDF attachment'))
            }

            if(this.validationErrors.submittedBy || this.validationErrors.submittedTo){
                missing.push(this.$i18n.t('Quotation Module.Signing details'))
            }

            return [...new Set(missing)]
        },
        FormatQuotationApprovalMissingMessage(requirements){
            const requiredText = (requirements || [])
                .map(item => `<strong>${this.EscapeHtml(item)}</strong>`)
                .join(', ')

            return `${this.EscapeHtml(this.$i18n.t('Quotation Module.Complete these required items before sending'))}<br>${requiredText}.<br>${this.EscapeHtml(this.$i18n.t('Quotation Module.Save changes then send again'))}`
        },
        ShowQuotationApprovalMissingModal(requirements){
            this.ShowQuotationFeedbackModal(
                'error',
                this.$i18n.t('Quotation Module.Missing approval details'),
                this.FormatQuotationApprovalMissingMessage(requirements),
                {
                    confirmText : 'OK'
                }
            )
        },
        GetQuotationSharepointFolderId(){
            return this.sharepointFolders?.projectSharepointFolders?.quotationFolderId
                || this.sharepointFolders?.quotationFolderId
                || this.sharepointFolders?.quotationFolder?.id
                || ''
        },
        EnsureQuotationSharepointFolder(){
            const folderId = this.GetQuotationSharepointFolderId()
            const driveId = this.systemSettings?.sharepointDriveId

            if(!driveId || !folderId){
                throw new Error(this.$i18n.t('Quotation Module.Quotation attachment folder unavailable'))
            }

            return {
                driveId,
                folderId
            }
        },
        NormalizeDirectoryLine(item){
            return {
                directoryId : item?.directoryId || '',
                name : item?.name || '',
                roleName : item?.roleName || ''
            }
        },
        NormalizeDirectoryList(list){
            return (list || [])
                .map(item => this.NormalizeDirectoryLine(item))
                .filter(item => item.directoryId || item.name || item.roleName)
        },
        HasSelectedDirectoryUser(list){
            return (list || []).some(item => item && item.directoryId)
        },
        ClearSigningValidation(){
            this.validationErrors = {
                contractDate : false,
                layoutDate : false,
                attention : false,
                submittedBy : false,
                submittedTo : false,
                attachedBoq : false,
                attachments : false
            }
        },
        RefreshQuotationFieldValidation(){
            if(this.validationErrors.contractDate && this.quotationData.contractDate){
                this.validationErrors.contractDate = false
            }

            if(this.validationErrors.layoutDate && this.quotationData.layoutDate){
                this.validationErrors.layoutDate = false
            }

            if(this.validationErrors.attention && this.HasAttentionClient){
                this.validationErrors.attention = false
            }

            if(this.validationErrors.attachedBoq && this.HasAttachedBoq){
                this.validationErrors.attachedBoq = false
            }

            if(this.validationErrors.attachments && this.HasQuotationAttachments()){
                this.validationErrors.attachments = false
            }
        },
        RefreshSigningValidation(){
            if(this.validationErrors.submittedBy && this.HasSelectedDirectoryUser(this.submittedTo)){
                this.validationErrors.submittedBy = false
            }

            if(this.validationErrors.submittedTo && this.HasSelectedDirectoryUser(this.additionalAttention)){
                this.validationErrors.submittedTo = false
            }
        },
        ValidateQuotationRequiredFields(){
            this.validationErrors = {
                ...this.validationErrors,
                contractDate : !this.quotationData.contractDate,
                layoutDate : !this.quotationData.layoutDate,
                attention : !this.HasAttentionClient
            }

            return !this.validationErrors.contractDate
                && !this.validationErrors.layoutDate
                && !this.validationErrors.attention
        },
        ValidateQuotationAttachments(){
            this.validationErrors = {
                ...this.validationErrors,
                attachments : !this.HasQuotationAttachments()
            }

            return !this.validationErrors.attachments
        },
        ValidateSigningDetails(){
            this.validationErrors = {
                contractDate : !!this.validationErrors.contractDate,
                layoutDate : !!this.validationErrors.layoutDate,
                attention : !!this.validationErrors.attention,
                submittedBy : !this.HasSelectedDirectoryUser(this.submittedTo),
                submittedTo : !this.HasSelectedDirectoryUser(this.additionalAttention),
                attachedBoq : !!this.validationErrors.attachedBoq,
                attachments : !!this.validationErrors.attachments
            }

            return !this.validationErrors.submittedBy && !this.validationErrors.submittedTo
        },
        GetQuotationChangeSnapshot(){
            const quotationData = JSON.parse(JSON.stringify(this.quotationData || {}))

            quotationData.contractDate = this.NormalizeQuotationDateForApi(quotationData.contractDate)
            quotationData.layoutDate = this.NormalizeQuotationDateForApi(quotationData.layoutDate)
            quotationData.scopeOfWork = this.NormalizeRichTextSpaces(quotationData.scopeOfWork)
            quotationData.termAndConditions = this.NormalizeRichTextSpaces(quotationData.termAndConditions)
            quotationData.submittedTo = (quotationData.submittedTo || []).map(item => {
                const submittedItem = { ...item }
                delete submittedItem.signature
                delete submittedItem.signatureBlob
                return submittedItem
            })

            return JSON.stringify({
                quotationData,
                attentionTo : this.NormalizeDirectoryLine(this.attentionTo),
                submittedTo : this.NormalizeDirectoryList(this.submittedTo),
                additionalAttention : this.NormalizeDirectoryList(this.additionalAttention),
                attachmentChanges : (this.attachmentChanges || []).map(file => ({
                    name : file.name || '',
                    size : file.size || 0,
                    lastModified : file.lastModified || 0
                })),
                RemovedFiles : (this.RemovedFiles || []).map(file => ({
                    id : file._id || '',
                    sharepointId : file.sharepointId || '',
                    attachmentName : file.attachmentName || ''
                }))
            })
        },
        SetQuotationBaseline(){
            this.quotationBaselineSnapshot = this.GetQuotationChangeSnapshot()
            this.haveChanges = false
        },
        RefreshQuotationChanges(){
            if(this.suspendChangeTracking || this.isLoading || !this.isEditMode){
                return
            }

            this.haveChanges = this.GetQuotationChangeSnapshot() !== this.quotationBaselineSnapshot
        },
        async UpdateQuotation(e){
            const self = this
            const btn = e && (e.currentTarget || e.target)
            if(self.isEditing){
                return
            }
            const updateData = JSON.parse(JSON.stringify(self.quotationData))
            updateData.scopeOfWork = self.NormalizeRichTextSpaces(updateData.scopeOfWork)
            updateData.termAndConditions = self.NormalizeRichTextSpaces(updateData.termAndConditions)
            updateData.contractDate = self.NormalizeQuotationDateForApi(updateData.contractDate)
            updateData.layoutDate = self.NormalizeQuotationDateForApi(updateData.layoutDate)
            if(!self.ValidateQuotationRequiredFields() || !updateData.quotationName || !updateData.quotationNumber){
                return 
            }

            // if(!self.ValidateQuotationAttachments()){
            //     self.ShowQuotationFeedbackModal(
            //         'error',
            //         self.$i18n.t('Quotation Module.Update Quotation'),
            //         'Please upload at least one PDF attachment before saving.',
            //         {
            //             confirmText : 'OK'
            //         }
            //     )
            //     return
            // }

            if(!self.ValidateSigningDetails()){
                return
            }
            
            updateData.listSubmitted = self.submittedTo
            updateData.additionalAttentionData = self.additionalAttention
            updateData.attentionClientData = self.attentionTo
            
            if(btn){
                btn.disabled = true
            }
            self.isEditing = true
            self.isLoading = true
            self.ShowQuotationFeedbackModal(
                'loading',
                self.$i18n.t('Quotation Module.Updating your Quotation'),
                self.$i18n.t('Quotation Module.Updating your Quotation and analyzing your table sheet')
            )
            // const getFiles = self.attachmentChanges

            try{
            //     let getToken = getFiles.length!=0 || this.RemovedFiles.length != 0 ?  await self.OpenPopup() : null

            //     let processFiles = []
            //     if(getFiles.length!=0){
            //         const quotationFolder = self.EnsureQuotationSharepointFolder()
            //         getToken = await self.OpenPopup()

            //         for(let f = 0; f < getFiles.length; f++){
            //             const file = getFiles[f]
            //             const reformated = ReformatFileName(file.name)
            //             const isUploaded = await UploadFileToFolder(getToken, quotationFolder.driveId,
            //                 quotationFolder.folderId, reformated,file)
            //             if(isUploaded){
            //                 processFiles.push({
            //                     sharepointId : isUploaded.id,
            //                     attachmentName : file.name,
            //                     attachmentSharepointName : reformated,
            //                     sharepointLink : isUploaded.webUrl,
            //                     isAdd : true
            //                 })
            //             }
            //         }
            //     }

            //     updateData.attachmentsChanges = processFiles
            //     if(updateData.attachments){
            //         updateData.attachmentsChanges.push(...updateData.attachments.filter(u=>u._id!=0))
            //     }
            //     if(updateData.attachmentsChanges.length==0){
            //         if(btn){
            //             btn.disabled = false
            //         }
            //         self.isLoading = false
            //         self.isEditing = false
            //         self.validationErrors.attachments = true
            //         self.ShowQuotationFeedbackModal(
            //             'error',
            //             self.$i18n.t('Quotation Module.Update Quotation'),
            //             'Please upload at least one PDF attachment before saving.',
            //             {
            //                 confirmText : 'OK'
            //             }
            //         )
            //         return
            //     }

            //     if(self.RemovedFiles.length!=0){
            //         const quotationFolder = self.EnsureQuotationSharepointFolder()
            //         let removePromise = []
            //         for(let r= 0; r < self.RemovedFiles.length; r++){

            //             removePromise.push(DeleteFileToFolder(getToken, quotationFolder.driveId,self.RemovedFiles[r].sharepointId))


            //         }

            //         await Promise.all(removePromise)
            //     }

                const res = await UpdateQuotation(updateData)
                if(btn){
                    btn.disabled = false
                }
                self.isLoading = false
                self.isEditing = false
                if(res!="OK"){
                    self.ShowQuotationFeedbackModal(
                        'error',
                        self.$i18n.t('Quotation Module.Sorry, there was a problem'),
                        self.GetQuotationSaveErrorMessage(res)
                    )
                    return
                }

                self.isEditMode = false
                self.ClearSigningValidation()
                self.ShowQuotationFeedbackModal(
                    'success',
                    self.$i18n.t('Success!'),
                    self.$i18n.t('Quotation Module.You have successfully updated your Quotation')
                )
                GetQuotationOne(updateData._id).then(data=>{
                    self.suspendChangeTracking = true
                    const jsonQuotation = self.ReformatJson(data)
                    self.quotationData = JSON.parse(JSON.stringify(jsonQuotation))
                    self.quotationDataIntial = JSON.parse(JSON.stringify(jsonQuotation))
                    self.RemovedFiles = []
                    self.attachmentChanges = []
                    self.$nextTick(()=>{
                        self.SetQuotationBaseline()
                        self.suspendChangeTracking = false
                    })
                })
            }catch(error){
                if(btn){
                    btn.disabled = false
                }
                self.isLoading = false
                self.isEditing = false
                if(error && error.response && error.response.status=='401'){
                    return self.$router.push('/unauthorized')
                }
                self.ShowQuotationFeedbackModal(
                    'error',
                    self.$i18n.t('Quotation Module.Sorry, there was a problem'),
                    self.GetQuotationSaveErrorMessage(error?.response?.data || error)
                )
            }
        },
        async ProcessAttachments(token, file){
            const self = this
            const quotationFolder = self.EnsureQuotationSharepointFolder()

            await UploadFileToFolder(token, quotationFolder.driveId, quotationFolder.folderId,ReformatFileName(file.name),file)
        },
        ReformatJson(data){
            const self = this
            data.layoutDate = ReformatDate(data.layoutDate,'YYYY-MM-DD')
            data.contractDate = ReformatDate(data.contractDate,'YYYY-MM-DD')
            data.scopeOfWork = self.NormalizeRichTextSpaces(data.scopeOfWork)
            data.termAndConditions = self.NormalizeRichTextSpaces(data.termAndConditions)

            if(data.attentionClient){
                self.attentionTo = {
                    roleName : data.attentionClient.roleInProject,
                    name : data.attentionClient.userId.fullname,
                    directoryId : data.attentionClient.userId._id
                }

            }else{
                data.attentionClient = {
                    userId : {fullname  :''},
                    projectDirectoryId : {_id : ''}
                }

                self.attentionTo = {
                    directoryId : '',
                    name : '',
                }
            }
            self.submittedTo = []
            if(data.submittedTo.length!=0){
                for(let x=0; x<data.submittedTo.length;x++){
                    const submitter = data.submittedTo[x]

                    self.submittedTo.push({
                        roleName : submitter.roleInProject,
                        name : submitter.userId.fullname,
                        directoryId : submitter.projectDirectoryId._id
                    })
                }
            }
            self.additionalAttention = []
            if(data.additionalAttention.length!=0){
                for(let x=0; x<data.additionalAttention.length;x++){
                    const submitter = data.additionalAttention[x]
                    self.additionalAttention.push({
                        roleName : submitter.roleInProject,
                        name : submitter.userId.fullname,
                        directoryId : submitter.projectDirectoryId
                    })
                }
            }

            self.additionalAttention.push({
                directoryId : '',
                name : ''
            })
            self.submittedTo.push({
                directoryId : '',
                name : ''
            })
            return data
        },
        CancelEdit(){
            const self = this
            if(self.haveChanges){
                self.$swal({
                    title: self.$i18n.t('Quotation Module.Discard Changes'),
                    text : self.$i18n.t('Quotation Module.You have unsaved changes, discard changes'),
                    showCancelButton: true,
                    icon: 'warning',
                    confirmButtonText: 'Discard',
                }).then((res)=>{
                    if(res.isConfirmed){
                        self.suspendChangeTracking = true
                        self.quotationData = JSON.parse(JSON.stringify(self.ReformatJson(self.quotationDataIntial)))
                        self.isEditMode = false
                        self.ClearSigningValidation()
                        self.RemovedFiles = []
                        self.attachmentChanges = []
                        self.$nextTick(()=>{
                            self.SetQuotationBaseline()
                            self.suspendChangeTracking = false
                        })
                    }
                })
            }else{
                self.isEditMode = false
                self.haveChanges = false
                self.ClearSigningValidation()
            }
        },
        OpenAddBoqToQuotation(){
            this.newBoq = {}
            // this.$refs.select2BoqToQuotation.ClearData()
        },
        AddBoqToQuotation(e){
            const btn = e.target
            const self = this
            if(self.isAddingToQuotation){
                return
            }

            if(!self.newBoq.boqId){
                return 
            }
            const quotationId = self.$route.params.id

            self.newBoq.quotationId = quotationId
            self.isAddingToQuotation = true

            btn.disabled = true
            AddBoQtoQuotation(self.newBoq).then(res=>{
                self.isAddingToQuotation = false
                btn.disabled = false
                if(res!='OK'){
                    self.$swal(self.$i18n.t('Add BoQ'),res,'warning')
                }else{
                    self.isSummaryLoading = true
                    self.$refs.closeModalAddBoqQuotation.click()
                    GetBoQsQuotationSummaries(quotationId).then(data=>{
                        self.isSummaryLoading = false
                        self.summaryByBoqList = data
                    })

                    SearchBoqNoQuotations({id : this.projectInfo._id,search : ''}).then(res=>{
                        self.boqList = res
                    })
                }
            })
        },
        OpenApproval(){
            this.quotationApprovalData = {}
        },
        OpenWorkFlowModal(){
            const self = this
            const missingRequirements = self.GetMissingQuotationApprovalRequirements()
            if(missingRequirements.length){
                self.ShowQuotationApprovalMissingModal(missingRequirements)
                return
            }

            ValidateQuotationBeforeApproval({
                quotationId : self.$route.params.id
            }).then((res)=>{
                if(res!='OK'){
                    self.ShowQuotationFeedbackModal(
                        'error',
                        self.$i18n.t('Quotation Module.Missing approval details'),
                        self.GetQuotationApprovalValidationMessage(res),
                        {
                            confirmText : 'OK'
                        }
                    )
                }else{
                    self.$router.push({name : 'BoqReviewerSetup', query : { qtnId : self.quotationId} })
                }
            })
        },
        ForApprovalQuotation(e){
            const btn = e.target
            const self = this

            if(self.isMovingForApproval){
                return
            }

            const newData = self.quotationApprovalData
            self.isApprovalClicked = true
            if(!newData.dateEnd || !newData.processId){
                return
            }
            self.isApprovalClicked = false
            newData.quotationId = this.$route.params.id

            btn.disabled = true
            self.isMovingForApproval = true
            ForApprovalQuotation(newData).then(res=>{
                btn.disabled = false
                self.isMovingForApproval = false
                if(res!='OK'){
                    self.$swal('For Approval',res,'warning')
                }else{
                    self.quotationApprovalData = {}
                    self.$refs.closeQuotationApprovalModal.click()
                    GetQuotationOne(newData.quotationId).then(data=>{
                        const jsonQuotation = self.ReformatJson(data)
                        self.quotationData = JSON.parse(JSON.stringify(jsonQuotation))
                        self.quotationDataIntial = JSON.parse(JSON.stringify(jsonQuotation))
                        
                    })
                    GetProcessItemQuotation(newData.quotationId).then((data)=>{
                        self.processItemData = data
                    })
                }
            })

        },
        PublishQuotation(){
            const self = this

            if(self.isPublishing){
                return 
            }
            const swalTitle = self.$i18n.t('Contract Sign Quotation')

            self.$swal({
                title: swalTitle,
                text : self.$i18n.t('This quotation will be the final version, Proceed?'),
                showCancelButton: true,
                icon: 'warning',
                confirmButtonText: 'Proceed',
                showLoaderOnConfirm : true,
                allowOutsideClick: () => !self.$swal.isLoading(),
                preConfirm : ()=>{
                    self.isPublishing = true
                    PublishQuotation(self.quotationData._id).then((res)=>{
                        self.isPublishing = false
                        if(res!="OK"){
                            return self.$swal(swalTitle,res,'warning')
                        }else{
                            self.$swal(swalTitle,self.$i18n.t('Published Quotation Successfully'),'success')
                            GetQuotationOne(self.quotationData._id).then(data=>{
                                const jsonQuotation = self.ReformatJson(data)
                                self.quotationData = JSON.parse(JSON.stringify(jsonQuotation))
                                self.quotationDataIntial = JSON.parse(JSON.stringify(jsonQuotation))
                            })
                        }
                    })
                }
            }).then(()=>{
                // if(res.isConfirmed){
                //     self.$swal('Published Quotation Successfully',res,'success')
                // }
            })
        },
        ExportToPdf(){
            window.print()
        },
        ResetData(){
            const self = this
            const quotationId = self.$route.params.id
            self.isSummaryLoading = true
            GetBoQsQuotationSummaries(quotationId).then(data=>{
                self.isSummaryLoading = false
                self.summaryByBoqList = data
            })

        },
        CreateBoqNew(e){
            const self = this
            const btn = e.target

            if(!self.newlyCreatedBoq.name){
                return
            }

            btn.disabled = true

            CreateBoq({
                projectId : self.projectInfo._id,
                currencyId : self.projectInfo.currencyId._id,
                reference : self.quotationData._id,
                name  :self.newlyCreatedBoq.name
            }).then(res=>{
                if(res.status==200){
                    self.$refs.closeModalNewQuotationAdd.click()
                    self.$router.push({name : 'BoqBuilder', params : {id : res.data}})
                }else{
                    btn.disabled = false
                    self.$swal('Create BoQ',res.data,'warning')
                }
            })

        },
        GetProcessItemRun(){
            location.reload()
        },
        OpenPopup(){

            if(this.sharepointToken){
                return this.sharepointToken
            }

            window.localStorage.setItem('z_token_share_value', '') 
            return new Promise((resolve) => {
             
                window.open(process.env.VUE_APP_REST_MAIN_API + '/api/auth/token/email?type=2&returnUrl='+encodeURIComponent(process.env.VUE_APP_BOQ_URL + '/page/empty/'), "_blank", "width=400,height=300")
                
                this.intervalClock = setInterval(async () => {
                    let check = window.localStorage.getItem('z_token_share_value')
                    if(check != ''){
                        const getToken = await GetTokenSharepointFromAuth()
                        this.sharepointToken = getToken
                        clearInterval(this.intervalClock)
                        resolve(getToken)
                    }
                }, 200);
            })
        },
        OpenAttachmentPicker(){
            const inputRef = this.$refs.fileDatas
            const input = Array.isArray(inputRef) ? inputRef[0] : inputRef
            if(input){
                input.click()
            }
        },
        OnChangeFiles(){
            const self = this
            const inputRef = self.$refs.fileDatas
            const input = Array.isArray(inputRef) ? inputRef[0] : inputRef
            if(!input || !input.files){
                return
            }

            let files = input.files
            // self.attachmentChanges
            for(let i = 0; i < files.length; i++){
                const attachment = files[i]
                const checkIndex = self.quotationData.attachments.findIndex(u=>u.attachmentName.toLowerCase()==attachment.name.trim().toLowerCase())
                if(checkIndex==-1){
                    self.quotationData.attachments.push({
                        attachmentName : attachment.name,
                        _id : 0
                    })
                    self.attachmentChanges.push(attachment)
                }
            }
            input.value = null
            
        },
        OnclickLink(url){
            window.open(url,'_blank')
        },
        RemoveAttachment(id,name){
            const getIndex = this.quotationData.attachments.findIndex(u=>u._id==id && u.attachmentName==name)
            if(getIndex !=-1 ){
                if(id!=0){
                    this.RemovedFiles.push(this.quotationData.attachments[getIndex])
                }else{
                    const getChangesIndex = this.attachmentChanges.findIndex(u=>u.name==name)
                    if(getChangesIndex!=-1){
                        this.attachmentChanges.splice(getChangesIndex,1)
                    }
                }
                
                this.quotationData.attachments.splice(getIndex,1)
            }

        }

    },
    computed : {
        ...mapGetters(['projectInfo','permission']),
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        QuotationProjectId(){
            return this.projectInfo?._id || this.quotationData.projectId?._id || this.quotationDataIntial.projectId?._id || ''
        },
        QuotationDisplayTitle(){
            const number = this.quotationDataIntial.quotationNumber || this.quotationData.quotationNumber || ''
            const name = this.quotationDataIntial.quotationName || this.quotationData.quotationName || ''
            return `${number} ${name}`.trim() || this.$t('Quotation')
        },
        FirstAttachedBoq(){
            return this.summaryByBoqList.length ? this.summaryByBoqList[0] : null
        },
        DisplayScopeOfWork(){
            return this.TranslateStandardQuotationRichText(this.quotationData.scopeOfWork)
        },
        DisplayTermAndConditions(){
            return this.TranslateStandardQuotationRichText(this.quotationData.termAndConditions)
        },
        EditableScopeOfWork: {
            get(){
                return this.quotationData.scopeOfWork
                    ? this.TranslateStandardQuotationRichText(this.quotationData.scopeOfWork)
                    : ''
            },
            set(value){
                this.quotationData.scopeOfWork = value
            }
        },
        EditableTermAndConditions: {
            get(){
                return this.quotationData.termAndConditions
                    ? this.TranslateStandardQuotationRichText(this.quotationData.termAndConditions)
                    : ''
            },
            set(value){
                this.quotationData.termAndConditions = value
            }
        },
        HasAttachedBoq(){
            return Array.isArray(this.summaryByBoqList) && this.summaryByBoqList.length > 0
        },
        ProjectDisplayName(){
            const project = this.projectInfo?._id ? this.projectInfo : (this.quotationData.projectId || this.quotationDataIntial.projectId || {})
            return `${project.projectNumber || ''} ${project.projectName || ''}`.trim() || '-'
        },
        AttachedBoqDisplayName(){
            if(!this.summaryByBoqList.length){
                return '-'
            }

            const firstBoq = this.summaryByBoqList[0]
            const firstName = firstBoq.name || '-'
            if(this.summaryByBoqList.length==1){
                return firstName
            }

            return `${firstName} + ${this.summaryByBoqList.length - 1} more`
        },
        HasAttentionClient(){
            if(this.isEditMode){
                return !!this.attentionTo.directoryId
            }

            return !!(
                this.attentionTo.directoryId
                || this.quotationData.attentionClient?.userId?._id
                || this.quotationData.attentionClient?.userId?.fullname
            )
        },
        HasSubmittedByUser(){
            if(this.isEditMode){
                return this.HasSelectedDirectoryUser(this.submittedTo)
            }

            return this.HasSelectedDirectoryUser(this.submittedTo)
                || (this.quotationData.submittedTo || []).some(item => item?.userId?._id || item?.userId?.fullname)
        },
        HasSubmittedToUser(){
            if(this.isEditMode){
                return this.HasSelectedDirectoryUser(this.additionalAttention)
            }

            return this.HasSelectedDirectoryUser(this.additionalAttention)
                || (this.quotationData.additionalAttention || []).some(item => item?.userId?._id || item?.userId?.fullname)
        },
        CanSaveQuotation(){
            return !this.isEditing
                && !!this.quotationData.contractDate
                && !!String(this.quotationData.quotationNumber || '').trim()
                && this.HasAttentionClient
                && !!String(this.quotationData.quotationName || '').trim()
                && !!this.quotationData.layoutDate
                // && this.HasQuotationAttachments()
                && this.HasSubmittedByUser
                && this.HasSubmittedToUser
        },
        CurrentApprovalStageName(){
            const stageName = ApprovalStageBoqObj[this.quotationDataIntial.approvalStage - 1]?.name || ''
            return stageName ? this.$i18n.t(stageName) : '-'
        },
        QuotationStatusDisplay(){
            if(!this.IsPublished){
                return this.CurrentApprovalStageName
            }

            const publishedDate = this.quotationDataIntial.publishedDate
                ? this.ReformatDate(this.quotationDataIntial.publishedDate)
                : '-'

            return `${this.$i18n.t('Published')} ${this.$i18n.t('on')} ${publishedDate}`
        },
        IsPublished(){
            return this.quotationDataIntial.approvalStage==ApprovalStageBoq.PUBLISHED
        },
        FormatLayoutDate(){
            const self = this
            if(self.quotationData.layoutDate){
                return ReformatDate(new Date(self.quotationData.layoutDate),"Do of MMMM, YYYY")
            }else{
                return '-'
            }
        },
        ReformatBoqSummary(){
            const self = this

            if(self.summaryByBoqList.length==0){
                return []
            }

            let parentLetter = 65

            let reformat = self.summaryByBoqList.map((u)=>{

                u.letter = String.fromCharCode(parentLetter++)
                let mainParentId = ''
                let mainParentCount = 1

                for(let x = 0; x < u.data.length; x++){
                    const getData = u.data[x]
                    let subCount = 1
                    if(getData.parents[0].costCodeId!=mainParentId){
                        mainParentId = getData.parents[0].costCodeId
                    
                        getData.mainCateg = {
                            label : u.letter + mainParentCount,
                            name : getData.parents[0].name
                        }
                    }
                    getData.label = u.letter +  mainParentCount + '.' + (subCount++)
                    getData.sellRate = ReformatNumber(u.data[x].sellRate)
                    getData.sellTotal = ReformatNumber(u.data[x].sellTotal)


                }


                return u
            })
            return reformat
        },
    //     SummaryRender(){
    //         const self = this

    //         if(self.summaryList.length==0){
    //             return []
    //         }

    //         const summaryData = JSON.parse(JSON.stringify(self.summaryList))

    //         let parent = ''
    //         let parentLetter = 65
    //         let subCount = 1
    //         let subTotal = 0

    //         const size = self.quotationData.projectId.size || 0

    //         let totalAll = 0

    //         summaryData.forEach((u)=>{
    //             totalAll += u.sellTotal
    //         })
    //         return summaryData.map((u,index)=>{
    //             u.willShowParent = false

    //             subTotal += u.sellTotal
                
    //             if(parent!=u.parent.costCodeId){
    //                 parent = u.parent.costCodeId
    //                 u.willShowParent = true
    //                 subCount = 1
    //                 u.label = String.fromCharCode(parentLetter++)
    //             }

    //             if(index==summaryData.length -1){
    //                 const subPerSize =subTotal / size
    //                 u.subTotal = {
    //                     label : String.fromCharCode(parentLetter - 1),
    //                     total : ReformatNumber(subTotal),
    //                     percentTotal :ReformatNumber((subTotal / totalAll) * 100,0),
    //                     perSize :  ReformatNumber(subPerSize)
    //                 }
    //                 u.overAllTotal = {
    //                     lastLabel : String.fromCharCode(parentLetter - 1),
    //                     percentTotal :totalAll ==0 ?'0' :'100',
    //                     perSize :  ReformatNumber(totalAll / size),
    //                     total : ReformatNumber(totalAll)
    //                 }
    //             }else if(u.parent.costCodeId!= summaryData[index + 1].parent.costCodeId){
    //                 const subPerSize =subTotal / size
    //                 const letter = parentLetter==65 ? 65 : parentLetter-1
    //                 u.subTotal = {
    //                     label : String.fromCharCode(letter),
    //                     total : ReformatNumber(subTotal),
    //                     percentTotal :ReformatNumber((subTotal / totalAll) * 100,0),
    //                     perSize :  ReformatNumber(subPerSize)
    //                 }
    //                 subTotal =0
    //             }


    //             u.index = subCount++
    //             u.perSize = ReformatNumber(u.sellTotal / size)
    //             u.percentTotal = ReformatNumber((u.sellTotal / totalAll) * 100,0)
    //             u.sellTotal = ReformatNumber(u.sellTotal)
    //             return u
    //         })
    //     }
    },
    watch : {
        quotationData: {
            handler() {
               this.RefreshQuotationChanges()
               this.RefreshQuotationFieldValidation()
            },
            deep: true
        },
        attentionTo: {
            handler() {
               this.RefreshQuotationChanges()
               this.RefreshQuotationFieldValidation()
            },
            deep: true
        },
        submittedTo: {
            handler() {
               this.RefreshQuotationChanges()
               this.RefreshSigningValidation()
            },
            deep: true
        },
        additionalAttention: {
            handler() {
               this.RefreshQuotationChanges()
               this.RefreshSigningValidation()
            },
            deep: true
        },
        attachmentChanges: {
            handler() {
               this.RefreshQuotationChanges()
               this.RefreshQuotationFieldValidation()
            },
            deep: true
        },
        summaryByBoqList: {
            handler() {
               this.RefreshQuotationFieldValidation()
            },
            deep: true
        },
        RemovedFiles : {
            handler() {
               this.RefreshQuotationChanges()
            },
            deep: true
        },
        isEditMode(value){
            if(value){
                this.suspendChangeTracking = true
                this.$nextTick(()=>{
                    this.SetQuotationBaseline()
                    this.suspendChangeTracking = false
                })
            }
        }
    },
    beforeUnmount() {
        if(this.intervalClock){
            clearInterval(this.intervalClock)
        }

        for(let x= 0; x< this.quotationData.submittedTo.length; x++){
            const blob = this.quotationData.submittedTo[x].signatureBlob
            if(blob){
                URL.revokeObjectURL(blob);
            }
        }

        // if(quotationData.submittedTo){

        // }
    },
    data(){
        return {
            projectUrl : process.env.VUE_APP_PROJECT_URL,
            boqUrl : process.env.VUE_APP_BOQ_URL,
            quotationData : {
                _id : 1,
                approvalStage : 1,
                attentionClient : {
                    userId : {fullname  :''}
                }
            },
            quotationDataIntial : {
                approvalStage : 1,
                attentionClient : {
                    userId : {fullname  :''}
                }
            },
            submittedTo : [],
            additionalAttention : [],
            attentionTo : {
                directoryId : '',
                name : ''
            },
            dateNow : new Date() ,
            quotationId : this.$route.params.id,
            consolidatedList : [],
            isLoading : true,
            isEditMode : false,
            isEditing : false,
            quotationFeedbackModal : {
                visible : false,
                type : 'loading',
                title : '',
                message : ''
            },
            quotationFeedbackToast : {
                visible : false,
                type : 'success',
                title : '',
                message : ''
            },
            isSummaryLoading : true,
            haveChanges : false,
            summaryList : [],
            summaryByBoqList : [],
            newBoq : {},
            isAddingToQuotation : false,
            isMovingForApproval : false,
            approvalProcessList : [],
            quotationApprovalData : {},
            isApprovalClicked : false,
            ApprovalStageBoq : ApprovalStageBoq,
            ApprovalStageBoqObj : ApprovalStageBoqObj,
            isPublishing : false,
            ModuleActionList : ModuleActionList,
            boqList : [],
            newlyCreatedBoq : {},
            processItemData : {
                status : 1,
                internalApprovers : [],
                externalApprovers: []
            },
            returnUrl : location.pathname,
            intervalClock : null,
            attachmentChanges : [],
            RemovedFiles : [],
            sharepointToken : null,
            sharepointFolders : null,
            systemSettings : null,
            quotationBaselineSnapshot : '',
            suspendChangeTracking : true,
            validationErrors : {
                contractDate : false,
                layoutDate : false,
                attention : false,
                submittedBy : false,
                submittedTo : false,
                attachedBoq : false,
                attachments : false
            },
        }
    }
}
